<template>
  <section id="impact" class="section bg-gradient-to-br from-primary to-primary-700 dark:from-primary-900 dark:to-primary-800 relative overflow-hidden">
    <!-- Background Decorations -->
    <div class="absolute inset-0 overflow-hidden pointer-events-none">
      <div class="absolute top-0 left-0 w-96 h-96 bg-accent/10 rounded-full blur-3xl"></div>
      <div class="absolute bottom-0 right-0 w-96 h-96 bg-accent/10 rounded-full blur-3xl"></div>
      <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full bg-grid-pattern opacity-5"></div>
    </div>

    <div class="container-custom relative z-10">
      <!-- Section Header -->
      <div class="text-center mb-16 animate-reveal">
        <h2 class="text-4xl md:text-5xl font-display font-bold text-white mb-4">
          Our Impact
        </h2>
        <p class="text-xl text-white/90 max-w-2xl mx-auto">
          Proven results for ambitious organizations
        </p>
      </div>

      <!-- Stats Grid -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-16 stagger-children">
        <StatCard
          v-for="stat in stats"
          :key="stat.id"
          :number="stat.number"
          :suffix="stat.suffix"
          :label="stat.label"
          :description="stat.description"
          :icon="stat.icon"
          :animated="true"
          class="stat-card-item"
        />
      </div>

      <!-- Industries We Serve -->
      <div class="mt-20">
        <h3 class="text-2xl md:text-3xl font-display font-bold text-white text-center mb-12">
          Industries We Serve
        </h3>

        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 stagger-children">
          <div
            v-for="industry in industries"
            :key="industry.id"
            class="group flex flex-col items-center text-center p-6 bg-white/10 dark:bg-white/5 backdrop-blur-sm rounded-xl hover:bg-white/20 dark:hover:bg-white/10 transition-all duration-300 border border-white/20 hover:border-white/40 industry-item"
          >
            <div
              class="w-16 h-16 bg-white/20 dark:bg-white/10 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300"
            >
              <component
                :is="industry.icon"
                :size="32"
                class="text-white"
              />
            </div>
            <p class="text-white font-semibold text-sm">
              {{ industry.name }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import StatCard from '@/components/ui/StatCard.vue';
import { stats, industries } from '@/data/stats.js';
</script>

<style scoped>
.bg-grid-pattern {
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 50px 50px;
}
</style>
